import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    ColorFill: {
        fill: '#39b54a'
    }
});

const TransferIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);

    return (
        <>
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 192.4 60.6"
            >
                <g>
                    <polygon
                        className={classesInline.ColorFill}
                        points="154,29.5 169.5,31.5 154,33.6 154,40.8 175.7,31.5 154,22.2 	"
                    />
                    <path
                        className={classesInline.ColorFill}
                        d="M114.8,27.3c-2.1,0-3.7,1.3-4.1,3.7h8.2C118.9,28.8,117.1,27.3,114.8,27.3z"
                    />
                    <path
                        className={classesInline.ColorFill}
                        d="M51.7,27.6c-2.3,0-4.5,1.7-4.5,5s2.2,5.1,4.5,5.1c2.4,0,4.6-1.8,4.6-5.1C56.3,29.4,54.1,27.6,51.7,27.6z"
                    />
                    <path
                        className={classesInline.ColorFill}
                        d="M191,0H1.4C0.6,0,0,0.6,0,1.4v57.7c0,0.8,0.6,1.4,1.4,1.4H191c0.8,0,1.4-0.6,1.4-1.4V1.4
		C192.4,0.6,191.7,0,191,0z M30.9,23.1h-5.8v18.2h-4.3V23.1H15v-3.5h15.9V23.1z M42.3,28.4h-1.1c-2.6,0-4.1,1-4.1,4.3v8.6h-4.3V24.1
		H37v2.7c1.1-1.8,2.9-2.9,5.3-2.9V28.4z M60.6,41.2h-4.4v-2.5c-1,1.5-3,2.8-5.7,2.8c-4.3,0-7.8-3.6-7.8-8.9s3.5-8.8,7.9-8.8
		c2.8,0,4.7,1.3,5.7,2.7v-2.5h4.4V41.2z M79.9,41.2h-4.3v-9.5c0-2.8-1.5-4.3-3.8-4.3c-2.4,0-3.9,1.5-3.9,4.3v9.5h-4.3V24.1h4.3v2.1
		c1.1-1.5,3-2.4,5.2-2.4c4,0,6.9,2.6,6.9,7.4V41.2z M89.2,41.5c-4.3,0-7.3-2.5-7.5-5.7H86c0.2,1.3,1.4,2.3,3.1,2.3
		c1.7,0,2.6-0.8,2.6-1.8c0-3.1-9.7-1.1-9.7-7.4c0-2.9,2.5-5.2,6.8-5.2c4.2,0,6.7,2.3,6.9,5.7h-4.2c-0.1-1.3-1.2-2.2-2.9-2.2
		c-1.6,0-2.5,0.7-2.5,1.6c0,3.1,9.5,1.2,9.7,7.5C95.9,39.3,93.4,41.5,89.2,41.5z M106,27.6h-3v13.6h-4.4V27.6h-2v-3.6h2v-0.9
		c0-4.2,2.4-6.2,7.2-6.1v3.7c-2.1-0.1-2.8,0.6-2.8,2.5v0.7h3V27.6z M123.3,34h-12.6c0.2,2.5,2,4,4.1,4c1.9,0,2.9-0.9,3.4-2.1h4.7
		c-0.9,3.2-3.8,5.7-8,5.7c-5,0-8.6-3.5-8.6-8.9c0-5.4,3.5-8.9,8.6-8.9c5,0,8.5,3.4,8.5,8.5C123.4,32.8,123.4,33.4,123.3,34z
		 M134.8,28.4h-1.1c-2.6,0-4.1,1-4.1,4.3v8.6h-4.3V24.1h4.3v2.7c1.1-1.8,2.9-2.9,5.3-2.9V28.4z M163.4,49.2
		c-10.4,0-18.9-8.5-18.9-18.9c0-10.4,8.5-18.9,18.9-18.9s18.9,8.5,18.9,18.9C182.3,40.7,173.8,49.2,163.4,49.2z"
                    />
                </g>
            </svg>
        </>
    );
};

export default TransferIcon;
